export default __webpack_public_path__ + "static/media/icon_weight_Medium.ad7d9dd1.png";